import protectedRoutes from './protectedRoutes';
import publicRoutes from './publicRoutes';
import authRoutes from './authRoutes';
import adminRoutes from './adminRoutes';
import eventRoutes from './eventRoutes';
import memberRoutes from './memberRoutes';

const allRoutes = [
  ...publicRoutes,
  ...authRoutes,
  ...protectedRoutes,
  ...adminRoutes,
  ...eventRoutes,
  ...memberRoutes
];

export default allRoutes;